import type { LuggageType } from "@daytrip/legacy-enums";
import { ChildSeatType, PassengerType } from "@daytrip/legacy-enums";
import { Exclude, Expose, Type } from "class-transformer";
import { IsArray, IsDefined, IsNumber, IsString, ValidateIf } from "class-validator";

@Exclude()
export class SimplePassenger {
    @IsString()
    @IsDefined()
    @Expose()
    public type: PassengerType;

    @IsNumber()
    @IsDefined()
    @ValidateIf((passenger) => passenger.type === PassengerType.Child)
    @Expose()
    public childSeatType?: ChildSeatType;

    @IsString()
    @Expose()
    public email: string;

    @IsString()
    @Expose()
    public firstName: string;

    @IsString()
    @Expose()
    public lastName: string;

    @IsArray()
    @Expose()
    @Type(() => Number)
    public luggage: Array<LuggageType> = new Array<LuggageType>();
}
